import React from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import logo from "../images/HAS LOGO.png";

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg custom-navbar">
      <div className="container-fluid">

        <Link className="navbar-brand brand-logo" to="/">
          <img src={logo} alt="Home Appliance Service Madurai" />

          <div className="brand-text">
            <span>Home Appliance</span>
            <small>Service & Support</small>
          </div>
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link className="nav-link" to="/">Home</Link>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/About">About</Link>
            </li>

            <li className="nav-item dropdown">
              <Link
                className="nav-link dropdown-toggle"
                to="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Service
              </Link>

              <ul className="dropdown-menu">
                <li><Link className="dropdown-item" to="/ac-service">AC Service</Link></li>
                <li><Link className="dropdown-item" to="/tv-service">TV Service</Link></li>
                <li><Link className="dropdown-item" to="/fridge-service">Fridge Service</Link></li>
                <li><Link className="dropdown-item" to="/microwave-oven-service">Microwave Oven Service</Link></li>
                <li><Link className="dropdown-item" to="/washing-machine-service">Washing Machine Service</Link></li>
                <li><Link className="dropdown-item" to="/water-heater-service">Water Heater Service</Link></li>
                <li><Link className="dropdown-item" to="/water-purifier-service">Water Purifier Service</Link></li>
              </ul>
            </li>

            <li className="nav-item">
              <Link className="nav-link" to="/contact">Contact</Link>
            </li>

          </ul>
        </div>

      </div>
    </nav>
  );
}